import clsx from "clsx";
import AreaChartCard from "../AreaChartCard/AreaChartCard";
import { StatsChartCardProps } from "./StatsChartCard.types";
import useStatsChartCard from "./hooks/useStatsChartCard";

function StatsChartCard({ className, stats, color, ...rest }: StatsChartCardProps) {
    const props = useStatsChartCard({ stats, color });

    return <AreaChartCard className={clsx("stats-chart-card", className)} {...props} {...rest} />;
}

export default StatsChartCard;
